import { createReducer, on } from '@ngrx/store';
import { SetIdentity } from './identity.actions';

export const OrgIdentityReducer = createReducer(
  {},

  on(SetIdentity, (state, { id, data }) => {
    if (!id) {
      return state;
    }

    return {
      ...state,
      [id]: data,
    };
  }),
);
